import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfigurationManagementService } from '../../../service/configuration-management.service';
import { LanguageManagementService } from '../../../service/language-management.service';
import { KeyValues5, LocalService, PageKey, TriggeredEvent } from '../../../service/local.service';
import { EditStartupConfigComponent } from '../../popups/edit-startup-config/edit-startup-config.component';

@Component({
  selector: 'app-startup-configs',
  templateUrl: './startup-configs.component.html',
  styleUrls: ['./startup-configs.component.scss']
})
export class StartupConfigsComponent implements OnInit {
  items: KeyValues5[]; lstSectionConfigKeys: string[] = ["startup", "table"]; parentId = ''; maxBodyHeight = 0;
  constructor(public localService: LocalService, private cdr: ChangeDetectorRef, private languageManagementService: LanguageManagementService, private modalService: NgbModal, private route: ActivatedRoute, private configurationManagementService: ConfigurationManagementService) { }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.route.params.subscribe(routeParams => {
      this.configurationManagementService.ensurePageActions(PageKey.StartupConfig);
      this.localService.saveUrl();
      this.localService.setBasicParams(routeParams.ctryCode, routeParams.userId, routeParams.interactionType);
      this.parentId = routeParams.parentId;
      this.onLoad();
    });
  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetCustomBodyHeight();
    this.cdr.detectChanges();
  }

  onLoad() {
    this.configurationManagementService.getStartups(this.parentId).subscribe(result => {
      this.items = result;      
    });
  }

  onActiveInactiveStatus(id) {

  }

  onOpenStartUp(id = '') {
    const modalRef = this.modalService.open(EditStartupConfigComponent, { ariaLabelledBy: 'modal-basic-title' });
    modalRef.componentInstance.id = id;
    modalRef.componentInstance.parentId = this.parentId;
    modalRef.result.then((result) => {
      if (result.event == TriggeredEvent.Ok) {
      }
    });
  }
}
